import { combineClasses } from "@/lib/utils";
import styles from "./PublishingOptions.module.scss";

export interface PublishingOption {
  value: string;
  label: string;
  caption: string;
}

export interface PublishingOptionsProps {
  options: PublishingOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const PublishingOptions = ({ options, value, onChange, disabled = false }: PublishingOptionsProps) => (
  <div className={styles.list}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        disabled={disabled}
        className={combineClasses(styles.row, value === option.value && styles.rowActive)}
        onClick={() => onChange(option.value)}
      >
        <span className={combineClasses(styles.radio, value === option.value && styles.radioActive)} />
        <span className={styles.rowText}>
          <span className={styles.rowLabel}>{option.label}</span>
          <span className={styles.rowCaption}>{option.caption}</span>
        </span>
      </button>
    ))}
  </div>
);

export default PublishingOptions;
